/**
 * Vigencia del contrato: tipo, fecha de inicio y fecha de término.
 *
 * Lo usan el formulario de contratos y el backend, igual que jornadaLaboral.js y
 * con las mismas restricciones: CommonJS y sin spread, for...of ni
 * desestructuración de arrays, para que el build de React no le inyecte imports.
 */

const TIPOS_CONTRATO = ['INDEFINIDO', 'PLAZO_FIJO'];

const texto = (v) => (v === null || v === undefined ? '' : String(v).trim());

const fecha = (v) => texto(v).slice(0, 10);

/** 'YYYY-MM-DD' + n años, como texto comparable con otras fechas ISO. */
function sumarAnios(iso, anios) {
    return `${Number(iso.slice(0, 4)) + anios}${iso.slice(4)}`;
}

/** Errores de la vigencia; vacío si cumple. */
function validarVigencia(contrato) {
    if (TIPOS_CONTRATO.indexOf(contrato.tipo_contrato) === -1) return ['Seleccione el tipo de contrato.'];
    if (contrato.tipo_contrato !== 'PLAZO_FIJO') return [];

    const inicio = fecha(contrato.fecha_inicio);
    const termino = fecha(contrato.fecha_termino);
    if (!termino) return ['Un contrato a plazo fijo requiere fecha de término.'];
    if (inicio && termino <= inicio) return ['La fecha de término debe ser posterior a la fecha de inicio.'];
    return [];
}

/**
 * Avisos que no bloquean: el art. 159 N°4 limita el plazo fijo a un año, o a dos
 * si el trabajador es gerente o tiene título profesional o técnico. El sistema no
 * sabe si lo tiene, así que sólo lo advierte.
 */
function advertenciasVigencia(contrato) {
    if (contrato.tipo_contrato !== 'PLAZO_FIJO') return [];
    const inicio = fecha(contrato.fecha_inicio);
    const termino = fecha(contrato.fecha_termino);
    if (!inicio || !termino || termino <= inicio) return [];

    if (termino >= sumarAnios(inicio, 2)) {
        return ['El plazo fijo supera los 2 años, el máximo que permite el art. 159 N°4 incluso a gerentes y profesionales.'];
    }
    if (termino >= sumarAnios(inicio, 1)) {
        return ['El plazo fijo supera 1 año: sólo se permite hasta 2 años si el trabajador es gerente o tiene título profesional o técnico (art. 159 N°4).'];
    }
    return [];
}

/** La fecha de término que se guarda: un contrato indefinido no tiene. */
function fechaTerminoPactada(contrato) {
    return contrato.tipo_contrato === 'PLAZO_FIJO' ? fecha(contrato.fecha_termino) || null : null;
}

module.exports = {
    TIPOS_CONTRATO,
    validarVigencia,
    advertenciasVigencia,
    fechaTerminoPactada,
};
